/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyKitItem from './pharmacy-kit-item';
import PharmacyKitItemDetail from './pharmacy-kit-item-detail';
import PharmacyKitItemUpdate from './pharmacy-kit-item-update';
import PharmacyKitItemDeleteDialog from './pharmacy-kit-item-delete-dialog';

const PharmacyKitItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyKitItem />} />
    <Route path="new" element={<PharmacyKitItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyKitItemDetail />} />
      <Route path="edit" element={<PharmacyKitItemUpdate />} />
      <Route path="delete" element={<PharmacyKitItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyKitItemRoutes;
